import React from 'react';
import { useConnect } from '@lore/query-connect';
import { tags_partner } from '../../../../utils/query-helpers';

export default function usePartners(state, network, schoolStart, schoolEnd, extra = {}, eager = {}, $aggregations = [], $having = {}) {
  return useConnect('user.find', {
    where: {
      eager: {
        $aggregations: $aggregations,
        $where: {
          ...tags_partner(),
          // networkId: network?.id,
          state: {
            $ilike: state
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra
        },
        $eager: eager,
        $having: $having
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
